import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { CustomersState, CurrentCustomer } from './types';
import type { ApiCustomer } from '~/api/types';

const initialState: CustomersState = {
    currentCustomer: null
};

export const customersSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        setCurrentCustomer: (
            state: CustomersState,
            action: PayloadAction<CurrentCustomer>
        ) => {
            if (!action.payload) {
                return state;
            }

            return {
                ...state,
                currentCustomer: action.payload
            };
        },
        updateCurrentCustomer: (
            state: CustomersState,
            action: PayloadAction<Partial<ApiCustomer>>
        ) => {
            if (!state.currentCustomer) {
                return state;
            }

            const currentCustomer: ApiCustomer = {
                ...state.currentCustomer,
                ...action.payload
            };

            return {
                ...state,
                currentCustomer
            };
        },
        resetCustomers: (): CustomersState => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialState;
        });
    }
});

export const { setCurrentCustomer, updateCurrentCustomer, resetCustomers } =
    customersSlice.actions;

export const selectCurrentCustomer = (state: RootState): CurrentCustomer =>
    state.customers.currentCustomer;

export default customersSlice.reducer;
